import React from "react";
import { Link } from "gatsby";
import { useTranslation } from "react-i18next";
import { FiPlus, FiMinus } from "react-icons/fi";

import { scrollToElement } from "../utils/subcategoryHelpers";
import { cn } from "../../utils/cnConfig";

export const TitleBox = ({
  to,
  textRight,
  textLeft,
  handleClick,
  className,
  scrollRef,
  theme,
}) => {
  const { t } = useTranslation();

  const onClick = (e) => {
    if (!to) {
      e.preventDefault(); // Prevents the default link behavior
    }
    if (handleClick) {
      handleClick();
    }
  };

  const themeLightClass =
    " border-creme-100 text-creme-100 hover:border-green hover:text-green";
  const themeGreenClass =
    " border-green text-green hover:border-brown hover:text-brown";

  return (
    <Link to={to || "#"} onClick={to && onClick()}>
      <div
        className={cn(
          "no-show-print border-b-[1px] cursor-pointer pb-3 flex justify-between items-center mb-8 transition-all duration-300",
          className,
          theme === "green" ? themeGreenClass : themeLightClass
        )}
      >
        <h3 className="text-3xl">{t(textLeft)}</h3>
        {textRight ? (
          <h3 className="text-3xl">{textRight}</h3>
        ) : (
          <FiPlus className="text-2xl" />
        )}
      </div>
    </Link>
  );
};

export const TitleBoxOnClick = ({
  keyTarget,
  showMore,
  handlePlusClick,
  setActiveBox,
  hidePlus,
  className,
  theme,
  scrollRef, // Assuming scrollRef is passed as a prop to this component
}) => {
  const { t } = useTranslation();

  const themeLightClass =
    " border-creme-100 text-creme-100 hover:border-green hover:text-green";
  const themeGreenClass =
    " border-green text-green hover:border-brown hover:text-brown";

  return (
    <div
      className={cn(
        "no-show-print border-b-[1px] cursor-pointer pb-3 uppercase flex justify-between items-center mb-8 transition-all duration-300",
        className,
        theme === "green" ? themeGreenClass : themeLightClass
      )}
      onClick={() => {
        !hidePlus && handlePlusClick(keyTarget, scrollRef);
        // scrollToElement(titleRef);
        // !hidePlus && setActiveBox(keyTarget);
        scrollToElement(scrollRef); // Call this function to scroll
      }}
    >
      <h3 className="text-3xl">{t(keyTarget)}</h3>
      {!hidePlus &&
        (!showMore[keyTarget] ? (
          <FiPlus className="text-2xl" />
        ) : (
          <FiMinus className="text-2xl" />
        ))}
    </div>
  );
};
